import SvgIcn from "../../data/IconCompo";

/**
 * Camp event top bar. Nav / CTA defaults can be overridden via props.
 */
export default function Header({
  logoIcon = "uud_icon",
  navItems = [
    { label: "概要", href: "#overview", id: "overview" },
    { label: "開催日時", href: "#schedule", id: "schedule" },
    { label: "対象者", href: "#audience", id: "audience" },
    { label: "アジェンダ", href: "#agenda", id: "agenda" },
    { label: "講師", href: "#instructor", id: "instructor" },
  ],
  activeNavId = null,
  applyLabel = "申し込み",
  applyHref = "#apply",
} = {}) {
  return (
    <header className="event-temp-header">
      <a className="event-temp-header__brand" href="/camp/event" aria-label="UUD CAMP" >
        <span className="event-temp-header__brand-text">
          <SvgIcn name="about_b" className="event-temp-header__logo-svg" />
          <span className="event-temp-header__brand-line">UUD <br /> CAMP</span>
        </span>
      </a>

      <nav className="event-temp-header__nav" aria-label="ページ内">
        <ul className="event-temp-header__nav-list">
          {navItems.map((item) => (
            <li key={item.id} className="event-temp-header__nav-item">
              <a
                href={item.href}
                className={
                  activeNavId != null && item.id === activeNavId
                    ? "event-temp-header__link event-temp-header__link--active"
                    : "event-temp-header__link"
                }
                aria-current={activeNavId != null && item.id === activeNavId ? "true" : undefined}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <a className="event-temp-header__cta" href={applyHref}>
        {applyLabel}
      </a>
    </header>
  );
}
 